(function () {
  "use strict";

  var module = angular.module("uwAgenda.views", [
    "uwAgenda.help",
    "uwAgenda.global",
  ]);

  module.config(["$stateProvider", ViewsConfig]);

  function ViewsConfig($stateProvider) {
    $stateProvider.state("Home.Views", {
      url: "views/:id",
      params: {
        id: { squash: true, value: null }
      },
      templateUrl:
        "/app/views/view-overview.html",
      controller: "ViewOverviewController",
      controllerAs: "vm",
      ncyBreadcrumb: {
        label: "{{'views' | translate}}",
      },
    });
  }
})();
